<div class="wrap">
  <div class="containerReturnHelp">
    <!-- <div class="returnToHome" (click)="goBack()" *ngIf="offerAddToPayment?.length > 0">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" appChangeColorTheme attribute="color">
      </fa-icon>
      Retour vers les offres du club
    </div> -->

    <!-- <button appChangeColorTheme attribute="bgc" class="faQuestionCircle" (click)="openDialogHelp()">
      <fa-icon [icon]="getFaIcon('faQuestionCircle')"></fa-icon>
      Aide
    </button> -->

  </div>


  <div class="list_offers">
    <h3>Mon panier</h3>

    <mat-spinner [diameter]="50" *ngIf="loading"></mat-spinner>
    <div class="offers_basket" *ngIf="!loading">
      <ng-container *ngIf="myShoppingBag.length ">

        <div class="card_mobile" *ngFor="let o of myShoppingBag, let i = index" [style.opacity]="o.isSelected ? 1 : .5">
          <div class="img">
            <app-image-offer [offerKey]="o.offerKey" [width]="100" [height]="'250px'"></app-image-offer>
            <!-- <img [src]="getImgOffer(o.image)" [alt]="o.offerName"> -->

            <div class="checkbox_and_photo_experience">
              <mat-checkbox [color]="color" (click)="checkAddToPayment(o)? addToPayment(o) : $event.preventDefault()"
                [checked]="o.isSelected">
              </mat-checkbox>
              <div class="photo_experience" *ngIf="o?.photoExperience">
                <p>{{o?.photoExperience}}</p>
              </div>
            </div>
            <div class="infos_sub_img">
              <div class="infos">
                <div class="icon">
                  <fa-icon [icon]="getFaIcon('faClockSolid')"></fa-icon>
                </div>
                {{o?.duration? o?.duration : 'NC'}}
              </div>
              <div class="infos">
                <div class="icon">
                  <fa-icon [icon]="getFaIcon('faMapMarkedAlt')"></fa-icon>
                </div>
                <p>
                  {{o?.practicePlace? o?.practicePlace: 'NC'}}
                </p>
              </div>
            </div>

          </div>
          <div class="description_price_action">
            <div class="description">
              <h4>{{o.offerName}}</h4>
              <p class="offer_description" [innerHTML]="o.description">
                <!-- {{o.description | textDescription}} -->
              </p>
              <div class="delete_copy_offer">
                <fa-icon matTooltip="Retirer cette offre" [icon]="getFaIcon('faTrashAlt')"
                  (click)="deleteInMyShoppingBag(o)" appChangeColorTheme attribute="color">
                </fa-icon>
              </div>
              <div class="price_label" *ngIf="o.hasSession">
                <strong>{{ getStatuPriceOfOffer(o, i)}}</strong>
              </div>
            </div>


            <app-manage-quantity [offer]="o" [index]="i" [type]="'mobile'" [updateQuantityValue]="o.traineeQuantity"
              [priceWithoutSessions]="getStatuPriceOfOffer(o, i)"
              (updateQuantityValues)="getNewValueOfQuantity($event)">
            </app-manage-quantity>

            <div class="status_offer_price" *ngIf="o.hasSession && o.sessionKey">
              <span [ngClass]="{status_of_offer: !o.isComplete, status_of_offer_valid:(o.isComplete ) }"
                (click)="!o.isComplete && o?.isSelected? opendialogCustomizeMySession(o): getMessageAddOfferToPaiment()">
                <fa-icon [icon]="getFaIcon('faEdit')" *ngIf="!o.isComplete"></fa-icon>
                {{o.isComplete? 'Offre personnalisée': 'Inscrire/Modifier les participants'}}
              </span>
              <span class="edit_param_offer" *ngIf="o.isComplete"
                (click)="o.isSelected ? opendialogCustomizeMySession(o): getMessageAddOfferToPaiment()"
                appChangeColorTheme attribute="bgc">
                <fa-icon [icon]="getFaIcon('faEdit')"></fa-icon>
                Inscrire/Modifier les participants
              </span>

            </div>

          </div>
        </div>

        <div class="card_tablet" *ngFor="let o of myShoppingBag, let i = index" [style.opacity]="o.isSelected ? 1 : .5">
          <div class="img">
            <app-image-offer [offerKey]="o.offerKey" [width]="100" [height]="'250px'"></app-image-offer>

            <!-- <img [src]="getImgOffer(o.image)" [alt]="o.offerName"> -->

            <div class="checkbox_and_photo_experience">
              <mat-checkbox [color]="color" [style.opacity]="1"
                (click)="checkAddToPayment(o) ? addToPayment(o) : $event.preventDefault()" [checked]="o.isSelected">
              </mat-checkbox>
              <div class="photo_experience" *ngIf="o?.photoExperience">
                <p>{{o?.photoExperience}}</p>
              </div>
            </div>
            <div class="infos_sub_img">
              <div class="infos">
                <div class="icon">
                  <fa-icon [icon]="getFaIcon('faClockSolid')"></fa-icon>
                </div>
                {{o?.duration? o?.duration : 'NC'}}
              </div>
              <div class="infos">
                <div class="icon">
                  <fa-icon [icon]="getFaIcon('faMapMarkedAlt')"></fa-icon>
                </div>
                <p>
                  {{o?.practicePlace? o?.practicePlace: 'NC'}}
                </p>
              </div>
            </div>

          </div>
          <div class="description_price_action">
            <div class="description">
              <h4>{{o.offerName}}</h4>
              <p class="offer_description" [innerHTML]="o.description">
                <!-- {{o.description | textDescription}} -->
              </p>
              <div class="delete_copy_offer">
                <!-- <fa-icon class="copy_offer" [icon]="getFaIcon('faCopy')" mat-raised-button matTooltip="Dupliquer"
                  (click)="o?.isSelected? duplicateOffer(o): getMessageAddOfferToPaiment()" appChangeColorTheme
                  attribute="color"></fa-icon> -->
                <fa-icon matTooltip="Retirer cette offre" [icon]="getFaIcon('faTrashAlt')"
                  (click)="deleteInMyShoppingBag(o)" appChangeColorTheme attribute="color">
                </fa-icon>
              </div>
            </div>

            <div class="status_offer_price">

              <div class="status_offer" *ngIf="o.hasSession && o.sessionKey">

                <span [ngClass]="{status_of_offer: !o.isComplete, status_of_offer_valid:o.isComplete  }"
                  (click)="!o.isComplete && o.isSelected ? opendialogCustomizeMySession(o): getMessageAddOfferToPaiment() ">
                  <fa-icon [icon]="getFaIcon('faCheckCircle')" *ngIf="o.isComplete"></fa-icon>
                  <fa-icon [icon]="getFaIcon('faEdit')" *ngIf="!o.isComplete"></fa-icon>
                  {{o.isComplete? 'Offre personnalisée': 'Inscrire/Modifier les participants'}}
                </span>

                <span class="edit_param_offer" *ngIf="o.isComplete"
                  (click)="o?.isSelected? opendialogCustomizeMySession(o): getMessageAddOfferToPaiment()"
                  appChangeColorTheme attribute="bgc">
                  <fa-icon [icon]="getFaIcon('faEdit')"></fa-icon>
                </span>

              </div>

              <div class="price_label" *ngIf="o.hasSession">
                <strong>{{ getStatuPriceOfOffer(o, i)}}</strong>
              </div>

            </div>

            <app-manage-quantity [offer]="o" [index]="i" [type]="'desktop'" [updateQuantityValue]="o.traineeQuantity"
              [priceWithoutSessions]="getStatuPriceOfOffer(o, i)"
              (updateQuantityValues)="getNewValueOfQuantity($event)">
            </app-manage-quantity>
          </div>
        </div>

        <div class="card_laptop" *ngFor="let o of myShoppingBag, let i = index" [style.opacity]="o.isSelected ? 1 : .5">
          <div class="img">
            <app-image-offer [offerKey]="o.offerKey" [width]="100" [height]="'250px'"></app-image-offer>

            <div class="checkbox_and_photo_experience">
              <mat-checkbox [color]="color" [style.opacity]="1"
                (click)="checkAddToPayment(o) ? addToPayment(o) : $event.preventDefault()" [checked]="o.isSelected">
              </mat-checkbox>
              <div class="photo_experience" *ngIf="o?.photoExperience">
                <p>{{o?.photoExperience}}</p>
              </div>
            </div>
            <div class="infos_sub_img">
              <div class="infos">
                <div class="icon">
                  <fa-icon [icon]="getFaIcon('faClockSolid')"></fa-icon>
                </div>
                {{o?.duration? o?.duration : 'NC'}}
              </div>
              <div class="infos">
                <div class="icon">
                  <fa-icon [icon]="getFaIcon('faMapMarkedAlt')"></fa-icon>
                </div>
                <p>
                  {{o?.practicePlace? o?.practicePlace: 'NC'}}
                </p>
              </div>
            </div>

          </div>

          <div class="description_price_action">

            <div class="description">
              <h4>{{o.offerName}}</h4>
              <p class="offer_description" [innerHTML]="o.description">
                <!-- {{o.description | textDescription}} -->
              </p>
              <div class="delete_copy_offer">
                <fa-icon matTooltip="Retirer cette offre" [icon]="getFaIcon('faTrashAlt')"
                  (click)="deleteInMyShoppingBag(o)" appChangeColorTheme attribute="color">
                </fa-icon>
              </div>
            </div>

          </div>
        </div>
      </ng-container>

      <p *ngIf="!myShoppingBag.length" class="no_offers">Vous n'avez aucun article dans votre panier.</p>

      <div class="wishes" *ngIf="wishes?.length">
        <h4>Mes favoris</h4>

        <ng-container *ngFor="let w of wishes">
          <div class="wish">
            <div class="img">
              <app-image-offer [offerKey]="w.offerKey" [width]="100" [height]="'100%'"></app-image-offer>

              <!-- <img [src]="getImgOffer(w.image)" [alt]="w.offerName"> -->
            </div>
            <div class="wish_content">
              <div class="title_price">
                <span><strong>{{w.offerName}}</strong></span>
                <span>
                  {{w.price}}
                  <fa-icon [icon]="isInMyWishes(w.offerKey)" [style.color]="getColorOfHeart(w.offerKey)"
                    (click)="addOrDeleteToMyWish(w, $event); $event.stopPropagation()" appChangeColorTheme
                    attribute="color">
                  </fa-icon>
                </span>
              </div>
              <div class="description_wish" [innerHTML]="w.description">
                <!-- {{w.description | textDescription}} -->
              </div>
              <div class="btn_action">
                <span [ngClass]="{add_basket: !isInBasket(w)}"
                  (click)="!isInBasket(w)? addToMyShoppingBag(w): null; $event.stopPropagation()"
                  *ngIf="(!w?.isExternalOffer && w.hasSession && w.sessions) || (!w?.isExternalOffer && !w.hasSession)"
                  appChangeColorTheme attribute="bgc">
                  <fa-icon [icon]="isInBasket(w) ? getFaIcon('faCheck') :  getFaIcon('faShoppingBasket')"></fa-icon>
                  {{ isInBasket(w)? "Ajouté " : "Ajouter " }}
                  <!-- <p *ngIf="!w?.isExternalOffer &&!w.sessions">Aucune session programmée</p> -->
                </span>
                <span class="add_basket" *ngIf="w?.isExternalOffer" appChangeColorTheme attribute="bgc">
                  <a [href]="w?.offerClubURL" target="_blank">
                    <fa-icon [icon]="getFaIcon('faExternalLinkAlt')"></fa-icon>
                    Voir site club
                  </a>
                </span>

                <span *ngIf="!w?.isExternalOffer && w.hasSession && !w.sessions">
                  <!-- <span *ngIf="checkSession(w)"> -->
                  <strong>Aucune session programmée</strong>
                </span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="offer_selected_wishes">
    <div class="offer_selected">

      <div class="total">
        <fa-icon [icon]="getFaIcon('faShoppingBasket')" appChangeColorTheme attribute="color"></fa-icon>
        <!-- <p>Total des offres selectionnées de mon panier</p> -->
        <p>Configuration et validation de votre panier</p>
      </div>

      <div class="no_offers" *ngIf="!offerAddToPayment?.length">
        Aucune offre
      </div>

      <ul *ngIf="offerAddToPayment?.length">
        <div *ngFor="let o of offerAddToPayment; index as i" class="oneOffer">
          <div class="list_item_offerAddToPayment" *ngIf="o?.isSelected"
            style="--numbOfItemInBasket:var(--numbOfItemInBasket){{offerAddToPayment?.length}}">
            <mat-checkbox [checked]="true" [color]="color" (click)="addToPayment(o)"></mat-checkbox>

            <li class="item_offerAddToPayment">
              <span class="label">{{o?.offerName}} <fa-icon *ngIf="o.isPayableAtClub"
                  [icon]="getFaIcon('faQuestionCircle')" appChangeColorTheme attribute="color"
                  matTooltip="Cette offre est payable au club">
                </fa-icon></span>
              <span class="price" *ngIf="!o.isComplete"><strong> À perso.</strong></span>
              <span class="session_price" *ngIf="o.isComplete && !o?.hasSession">
                <fa-icon [icon]="getFaIcon('faInfoCircle')" appChangeColorTheme attribute="color"
                  *ngIf="o.advancePayment > 0" [matTooltip]="'Il y a un acompte de ' + o.advancePayment + '€'">
                </fa-icon>
                <!-- {{o?.sessionTotalPrice}}€ -->
              </span>
            </li>
          </div>
          <div class="status_offer_price" *ngIf="o?.isSelected && o.sessionKey">
            <div class="status_offer" *ngIf="o.hasSession">
              <span [ngClass]="{status_of_offer: !o.isComplete, status_of_offer_valid:o.isComplete  }"
                (click)="!o.isComplete && o.isSelected ? opendialogCustomizeMySession(o): null">
                <fa-icon [icon]="getFaIcon('faCheckCircle')" *ngIf="o.isComplete"></fa-icon>
                <fa-icon [icon]="getFaIcon('faEdit')" *ngIf="!o.isComplete"></fa-icon>
                {{o.isComplete? 'Offre personnalisée': 'Inscrire/Modifier les participants'}}
              </span>
              <span class="edit_param_offer" *ngIf="(o.isComplete)"
                (click)="o?.isSelected? opendialogCustomizeMySession(o) : getMessageAddOfferToPaiment()"
                appChangeColorTheme attribute="bgc">
                <fa-icon [icon]="getFaIcon('faEdit')"></fa-icon>
                Inscrire/Modifier les participants
              </span>

            </div>
            <div class="price_label" *ngIf="o.hasSession">
              <fa-icon [icon]="getFaIcon('faInfoCircle')" appChangeColorTheme attribute="color"
                *ngIf="o.advancePayment > 0" [matTooltip]="'Il y a un acompte de ' + o.advancePayment + '€'"></fa-icon>
              <strong>{{ getStatuPriceOfOffer(o, i)}}</strong>
            </div>
          </div>

          <app-manage-quantity *ngIf="o?.isSelected" [offer]="o" [index]="i" [type]="'desktop'"
            [myShoppingBag]="myShoppingBag" [priceWithoutSessions]="getStatuPriceOfOffer(o, i)"
            [updateQuantityValue]="o.traineeQuantity" (updateQuantityValues)="getNewValueOfQuantity($event)">
          </app-manage-quantity>

          <!-- <div class="session" *ngIf="o?.isComplete && o?.isSelected && o.hasSession">

            <span class="session_label">
              <fa-icon [icon]="getFaIcon('faCalendarAlt')"></fa-icon>
              <ng-container *ngIf="o.hasSession">
                {{getSessionOfferBasket(o)?.dateLib}} -
                {{getSessionOfferBasket(o)?.sessionStartDate | date: "shortDate":'UTC'}}
              </ng-container>

            </span>
            <span class="session_price">
              <fa-icon [icon]="getFaIcon('faInfoCircle')" appChangeColorTheme attribute="color"
                *ngIf="o.advancePayment > 0" [matTooltip]="'Il y a un acompte de ' + o.advancePayment + '€'"></fa-icon>
              {{o?.sessionTotalPrice}}€
            </span>
          </div> -->

        </div>
        <li *ngIf="!noOfferInBasket().length" class="no_offer_to_perso">Aucune offre sélectionnée </li>

        <li *ngIf="basketWithPrice.promoCodeDiscount && basketWithPrice.promoCodeName" class="last_item">
          <span class="label">Code Promo <i>"{{basketWithPrice.promoCodeName}}"</i>
            <button type="button" matTooltip="Retirer le code promo" mat-icon-button color="primary"
              (click)="removePromoCode()">
              <fa-icon [icon]="getFaIcon('faTrashAlt')" appChangeColorTheme attribute="color"></fa-icon>
            </button>
          </span>
          <span class="price"><strong>-{{basketWithPrice.promoCodeDiscount}}€</strong></span>
        </li>

        <hr *ngIf="licences?.length">
        <br>

        <div class="add_licence" *ngIf="licences?.length">
          <div class="licence_title">
            <h5 class="messageRed">L'ajout de licence(s) est automatique car l'un des participants n'a pas renseigné son
              n° de licence
            </h5>
            <!-- <span><strong>x{{licences?.length}}</strong></span> -->
          </div>

          <div class="licence_content">
            <div class="licence_item" *ngFor="let l of licences">
              <p>{{l.sessions[0].dateLib}}</p>
              <span><strong>{{l.sessionTotalPrice}}€</strong></span>
            </div>
          </div>
        </div>

        <li class="last_item last_item_first"><span class="label">Total</span> <span
            class="price"><strong>{{totalPrice}}€</strong></span>
        </li>
        <li class="last_item" *ngIf="totalDiscount"><span class="label">Total remisé</span> <span
            class="price"><strong>{{totalDiscount}}€</strong></span></li>
        <li class="last_item" *ngIf="basketWithPrice.grandDiscount > 0"><span class="label">Réduction supplémentaire
          </span> <span class="price"><strong>{{basketWithPrice.grandDiscount}}%</strong></span></li>
        <li class="last_item" *ngIf="basketWithPrice.grandDiscount > 0"><span class="label">Total remisé </span> <span
            class="price"><strong>{{basketWithPrice.discountedGrandTotal}}€</strong></span></li>
      </ul>

      <div class="discount" *ngIf="activePromoCode">

        <h5>Code promo</h5>
        <form [formGroup]="discountForm" (ngSubmit)="applyPromoCode()">
          <mat-form-field appearance="outline">
            <mat-label>Appliquer un code promo</mat-label>
            <input matInput type="text" formControlName="promoCodeName">
          </mat-form-field>
          <button mat-raised-button [color]="color" type="submit">Valider</button>
        </form>

        <div class="message_discount" *ngIf="messageDiscount">{{messageDiscount}}</div>
      </div>

      <!-- <div *ngIf="offerAddToPayment?.length > 0" class="goBackClub" appChangeColorTheme attribute="bgc"
        (click)="openDialogComment()">
        Ajouter un commentaire
      </div> -->

      <div *ngIf="offerAddToPayment?.length > 0" class="goBackClub" appChangeColorTheme attribute="bgc"
        (click)="goHome()">
        Continuer les achats d'offres du club
      </div>

      <div class="cgv" *ngIf="offerAddToPayment?.length">

        <mat-checkbox [color]="color" (change)="acceptCGV($event)" [checked]="cgvAccepted"> J'accepte
        </mat-checkbox>
        <span (click)="downloadCGV()" appChangeColorTheme attribute="color">les conditions générales de vente </span>
      </div>

      <div id="confirm_book"
        [ngClass]="{payment_active: allMyOffersIsComplete(),  payment_deactive: (!allMyOffersIsComplete() || !offerAddToPayment?.length)}"
        (click)="allMyOffersIsComplete() && authoToClick ? bookOffer(): null">
        <ng-container *ngIf="authoToClick">
          <fa-icon [icon]="getFaIcon('faLock')"></fa-icon>
          Passer commande
          <!-- {{ offerAddToPayment?.length <= 1?'Je confirme cette réservation '+ '(' + totalPrice + '€)' : 'Je confirme ces réservations ' + '(' + totalPrice + '€)' }} -->
        </ng-container>
        <div class="spinner_confirm_basket" *ngIf="!authoToClick">
          <mat-spinner [diameter]="20"></mat-spinner>
        </div>
      </div>

      <div class="pdf_basket" appChangeColorTheme attribute="bgc" (click)="getPdfBasket()">
        <fa-icon [icon]="getFaIcon('faFilePdf')"></fa-icon>
        Exporter mon devis
      </div>


      <p *ngIf="getOffertoPersoNoComplete()?.length > 0" class="message_for_valid">Il vous reste
        <strong>{{getOffertoPersoNoComplete()?.length}}</strong>
        {{getOffertoPersoNoComplete()?.length > 1? 'offres' : 'offre'}} à paramétrer pour valider
      </p>

    </div>
  </div>

</div>
